import React from 'react';
import { CustomerOption, NewCloseData } from './types';
import { getPeriodTypeLabel } from './utils';

const readOnlyInputClass =
  'w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm bg-gray-100 cursor-not-allowed focus:outline-none';

interface ReadonlyPeriodFieldProps {
  periodType: string;
}

export const ReadonlyYearField: React.FC<{ yearType: string }> = ({ yearType }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">
      Жил <span className="text-red-500">*</span>
    </label>
    <input
      type="text"
      value={yearType}
      readOnly
      className={readOnlyInputClass}
    />
  </div>
);

export const ReadonlyPeriodField: React.FC<ReadonlyPeriodFieldProps> = ({ periodType }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700 mb-2">Хугацаа</label>
    <input
      type="text"
      value={getPeriodTypeLabel(periodType)}
      readOnly
      className={readOnlyInputClass}
    />
  </div>
);

interface CloseContextSummaryProps {
  customers: CustomerOption[];
  newCloseData: NewCloseData;
}

export const CloseContextSummary: React.FC<CloseContextSummaryProps> = ({
  customers,
  newCloseData,
}) => {
  const customer = customers.find(c => c.Oid === newCloseData.CustomerOid);
  const customerLabel = customer
    ? `${customer.CustomerName || ''} (${customer.CustomerID || ''})`
    : '-';

  return (
    <div className="mb-4 text-sm text-gray-700 space-y-1">
      <p><span className="font-medium">Харилцагч:</span> {customerLabel}</p>
      <p className="flex flex-wrap gap-x-6 gap-y-1">
        <span><span className="font-medium">Жил:</span> {newCloseData.YearType || '-'}</span>
        <span><span className="font-medium">Хугацаа:</span> {getPeriodTypeLabel(newCloseData.PeriodType)}</span>
      </p>
    </div>
  );
};
